import React, { useCallback, useEffect, useState } from "react";

import { usePrevious } from"../../../../../hooks";
import { USPTOCategoryService } from "../../../../../../services/USPTOCategoryService";
import AsyncSelect from "../../../../controls/AsyncSelect";

function CategorySelect({
  goods,
  id,
  hint,
  label,
  emptyLabel,
  placeholder,
  required,
  validated,
  defaultInvalidMessage,
  value,
  onChange,
  ...restProps
}) {
  const [loading, setLoading] = useState(false);
  const [rawValue, setRawValue] = useState(null);
  const [clazzValue, setClazzValue] = useState(null);
  const prevGoods = usePrevious(goods);

  const handleChange = useCallback((e) => {
    const { value, clazz } = e.target;
    setRawValue(value);
    setClazzValue(clazz);
    onChange && onChange(e);
  }, [onChange]);

  const loadOptions = async (search, prevOptions, { page }) => {
    const options = [];
    let hasMore = false;

    setLoading(true);

    try {
      const {
        elements,
        maxPerPage,
        totalResults,
      } = await USPTOCategoryService.getList({
        page,
        count: 10,
        search,
        isGoods: goods === "true",
      });

      hasMore = totalResults > maxPerPage * page;
      
      elements.forEach(({ termId, description, clazz }) => {
        options.push({
          label: `${termId} - ${description}`,
          value: `${termId} - ${description}`,
          clazz: clazz,
        });
      });
    } catch(e) {
      setLoading(false);

      return {
        options: [],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }

    setLoading(false);

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  useEffect(() => {
    if (prevGoods !== goods && value) {
      const checkGoodsCategory = async () => {
        setLoading(true);

        const { elements } = await USPTOCategoryService.getList({
          page: 1,
          count: 5,
          termId: value?.split(" - ")[0],
          isGoods: goods,
        });

        const { termId, description, clazz } = elements[0] || {};

        setRawValue(termId ? `${termId} - ${description}` : null);
        setClazzValue(clazz);
        setLoading(false);
      };

      checkGoodsCategory();
    }
  }, [prevGoods, goods, value]);
  useEffect(() => {
    if (!value) {
      setRawValue(null);
      setClazzValue(null);
    }
  }, [value]);

  return (
    <AsyncSelect
      refreshKey={goods}
      id={id}
      hint={hint}
      label={label}
      emptyLabel={emptyLabel}
      placeholder={placeholder}
      required={required}
      loading={loading}
      loadOptions={loadOptions}
      validated={validated}
      defaultInvalidMessage={defaultInvalidMessage}
      value={rawValue}
      onChange={handleChange}
      clazz={clazzValue}
      {...restProps}
    />
  );
}

export default CategorySelect;
